import { render, staticRenderFns } from "./ActionPersonStriker.vue?vue&type=template&id=ccb0c18a"
import script from "./ActionPersonStriker.vue?vue&type=script&lang=js"
export * from "./ActionPersonStriker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports